import React, { useState, useCallback } from 'react';
import { Icon, Tooltip } from '@kis-technologies/kis-ui';
import ToolTipBody from './ToolTipBody';
import { ValidPasswordToolTipProps } from '../types';

export const ValidPasswordToolTip: React.FC<ValidPasswordToolTipProps> = (props: ValidPasswordToolTipProps) => {
  const [showOnHover, setShowOnHover] = useState(false);

  const toggleTooltipHoverVisibility = useCallback(() => {
    if (!props.showValidPasswordInfo) {
      setShowOnHover((showItOnHover) => !showItOnHover);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.showValidPasswordInfo, showOnHover]);

  return (
    <>
      <Tooltip
        open={props.showValidPasswordInfo || showOnHover}
        disableFocusListener
        disableTouchListener
        title={<ToolTipBody value={props.value} />}
        placement="top-end"
        slotProps={{
          tooltip: {
            sx: {
              background: '#fff',
              border: '1px solid #2a2a2a',
              borderRadius: '10px',
              padding: '0.5rem'
            }
          }
        }}
      >
        <span
          data-testid="pwd-info"
          onMouseEnter={() => toggleTooltipHoverVisibility()}
          onMouseLeave={() => toggleTooltipHoverVisibility()}
          style={{ display: 'flex', alignItems: 'center', height: '30px' }}
        >
          <Icon name="InfoOutlined" sx={{ color: 'black' }} />
        </span>
      </Tooltip>
    </>
  );
};
